<template>
  <div class="locale-content">
    <p>
      CAnnect is a corporate social network, a professional place dedicated to IWM Group employees that
      facilitates team cohesion, knowledge sharing and the anchoring of our Agile practices.
    </p>
    <p>
      Users can create public or private communities to share content and their skills & interests within their
      teams or a to a network of people interested.
    </p>
    <p>
      This solution was born in November 2017 at Crédit Agricole CIB, Indosuez acquired the rights and adapted
      CAnnect to our needs by developing a whole series of new features with the Innovation Lab.
    </p>
    <p>
      The objective is to offer you a space to share and discuss ideas with a user experience :
    </p>
    <ul>
      <li>100% secure;</li>
      <li>Dynamic;</li>
      <li>Close to your needs;</li>
      <li>Easy to use;</li>
      <li>Close to today's uses.</li>
    </ul>
    <p v-if="showCommunityHowTo">
      <strong>To learn more about CAnnect, visit the community:</strong> <br />
      <span class="link" @click="goToHowTo()"><u>How to use CAnnect / Comment utiliser CAnnect</u></span>
    </p>
  </div>
</template>

<script>

export default {
  name: 'ReadAboutEn',
  props: {
    showCommunityHowTo: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToHowTo() {
      this.$emit('goToCommunity')
    }
  }
}
</script>
